import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { BRAND, CONTACT, TOWNS, SERVICES } from "../../data/site";
import { track, EVENTS } from "../../lib/analytics";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-navy px-6 py-16 text-white/80 md:px-10 lg:px-16"
  >
    <div className="container-hh grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-1">
        <p className="font-serif text-3xl text-white">Harbor Home</p>
        <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/70">
          {BRAND.tagline}
        </p>
        <div className="mt-5 flex gap-3">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            onClick={() => track(EVENTS.INSTAGRAM_CLICK, { location: "footer" })}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-teal"
            aria-label="Instagram"
          >
            <Instagram className="h-5 w-5 text-white" />
          </a>
          <a
            href={CONTACT.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-teal"
            aria-label="Facebook"
          >
            <Facebook className="h-5 w-5 text-white" />
          </a>
        </div>
      </div>

      <div>
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-seafoamlight">
          Services
        </p>
        <ul className="space-y-2 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={s.path}
                className="transition-colors hover:text-white"
                data-testid={`footer-service-${s.slug}`}
              >
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-seafoamlight">
          Serving the South Shore
        </p>
        <ul className="space-y-2 text-sm">
          {TOWNS.map((t) => (
            <li key={t}>{t}, MA</li>
          ))}
        </ul>
      </div>

      <div>
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-seafoamlight">
          Get in Touch
        </p>
        <a
          href={CONTACT.phoneHref}
          data-testid="footer-phone"
          onClick={() => track(EVENTS.CALL_CLICK, { location: "footer" })}
          className="flex items-center gap-2 text-sm transition-colors hover:text-white"
        >
          <Phone className="h-4 w-4" /> {CONTACT.phone}
        </a>
        <a
          href={CONTACT.emailHref}
          data-testid="footer-email"
          className="mt-3 flex items-center gap-2 text-sm transition-colors hover:text-white"
        >
          <Mail className="h-4 w-4" /> {CONTACT.email}
        </a>
        <Link to="/book" className="btn-teal mt-6" data-testid="footer-book-btn">
          Book Your Free Walkthrough
        </Link>
      </div>
    </div>

    <div className="container-hh mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row">
      <p>© {new Date().getFullYear()} Harbor Home Concierge. All rights reserved.</p>
      <div className="flex gap-6">
        <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">
          Privacy
        </Link>
        <Link to="/terms" className="hover:text-white" data-testid="footer-terms">
          Terms
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
